import React from "react";

import { MainLayout } from "~/components/layout/MainLayout";
import { PageHeader } from "~/components/layout/PageHeader";
import { useAuthCheck } from "~/hooks/useAuthCheck";
import { InterestRateConfigSection } from "~/pages/components/InterestRateConfigSection";
import { PaymentReminderRulesSection } from "~/pages/components/PaymentReminderRulesSection";

const ConfigPayments: React.FC = () => {
  // Get the user role using the same hook that RoleBasedRouter uses
  const { userRole, isLoading } = useAuthCheck("/config-payments");

  if (isLoading || !userRole) {
    return (
      <div className="flex h-screen items-center justify-center">
        Cargando...
      </div>
    );
  }

  return (
    <MainLayout userRole={userRole}>
      <div className="flex h-full w-full max-w-[100vw] flex-col items-center justify-start px-6 py-10 md:max-w-[60vw] lg:max-w-[70vw] xl:max-w-[80vw]">
        <div className="w-full max-w-4xl">
          <PageHeader title="Configuración de Pagos" />

          <div className="mt-6 space-y-8">
            {/* Interest Rates Section */}
            <div className="rounded-lg bg-white p-6 shadow">
              <h2 className="mb-4 text-xl font-semibold">Tasas de Interés</h2>
              <InterestRateConfigSection />
            </div>

            {/* Payment Reminder Rules Section */}
            <div className="rounded-lg bg-white p-6 shadow">
              <h2 className="mb-4 text-xl font-semibold">
                Recordatorios de Pago
              </h2>
              <PaymentReminderRulesSection />
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default ConfigPayments;
